import { diContainer } from "@/di";
import AbstractDownloadHandler from "./AbstractDownloadHandler";
import { MimeTypes, IDownload } from "../types";
import { DITypes } from "@/core/@types/types";
import "reflect-metadata";
import { injectable } from "inversify";

@injectable()
export default class PDFDownloadHandler extends AbstractDownloadHandler {
  handle(mimeType: MimeTypes): IDownload | null {
    if (mimeType === MimeTypes.PDF)
      return diContainer.get<IDownload>(DITypes.DOWNLOAD_PDF);

    return super.handle(mimeType);
  }
}
